module.exports = __webpack_public_path__ + "img/Group 9740.7db60377.svg";